import React, { useState, useEffect } from "react";
const NCSCUpdate1 = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [data, setdata] = useState("")
    const [formData, setFormData] = useState({
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),

        GenderTotal3: 0,
        GenderTotalVIEW: 0,
        GenderMale4: 0,
        GenderFemale5: 0,
        GenderTransgender6: 0,
        CasteSc7: 0,
        CasteSt8: 0,
        CasteObc9: 0,
        CasteOthers10: 0,
        Vhmale11: 0,
        Vhfemale12: 0,
        Vhtransgender13: 0,
        Hhmale14: 0,
        Hhfemale15: 0,
        Hhtransgender16: 0,
        Ohmale17: 0,
        Ohfemale18: 0,
        Ohtransgender19:0,
        clmale20: 0,
        Clfemale21: 0,
        Cltransgender22: 0,
        Mrmale23: 0,
        Mrfemale24: 0,
        Mrtransgender25: 0,
        Mdmale26: 0,
        Mdfemale27: 0,
        Mdtransgender28: 0,
        OthersMale29: 0,
        OthersFemale30: 0,
        OthersTransgender31: 0,
 

    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }

        await fetch(process.env.REACT_APP_API_LINK +'api/NCSCDA/GetNcscDaDetails', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    setFormData({
                        GenderTotal3: maindata.genderTotal3,
                        GenderMale4: maindata.genderMale4,
                        GenderFemale5: maindata.genderFemale5,
                        GenderTransgender6: maindata.genderTransgender6,
                        CasteSc7: maindata.casteSc7,
                        CasteSt8: maindata.casteSt8,
                        CasteObc9: maindata.casteObc9,
                        CasteOthers10: maindata.casteOthers10,
                        Vhmale11: maindata.vhmale11,
                        Vhfemale12: maindata.vhfemale12,
                        Vhtransgender13: maindata.vhtransgender13,
                        Hhmale14: maindata.hhmale14,
                        Hhfemale15: maindata.hhfemale15,
                        Hhtransgender16: maindata.hhtransgender16,
                        Ohmale17: maindata.ohmale17,
                        Ohfemale18: maindata.ohfemale18,
                        Ohtransgender19: maindata.ohtransgender19,      
                        Clmale20: maindata.clmale20,
                        Clfemale21: maindata.clfemale21,
                        Cltransgender22: maindata.cltransgender22,
                        Mrmale23: maindata.mrmale23,
                        Mrfemale24: maindata.mrfemale24,
                        Mrtransgender25: maindata.mrtransgender25,
                        Mdmale26: maindata.mdmale26,
                        Mdfemale27: maindata.mdfemale27,
                        Mdtransgender28: maindata.mdtransgender28,
                        OthersMale29: maindata.othersMale29,
                        OthersFemale30: maindata.othersFemale30,
                        OthersTransgender31: maindata.othersTransgender31,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }

        await fetch(process.env.REACT_APP_API_LINK +'api/NCSCDA/UpdateDetailsNcscDa', {
            method: 'POST',
            headers: {  
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => //console.log(data))
                    setdata(data)
            )

    };

    




    useEffect(() => {
        getdata()

    }, [props.Change])


    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };

    return (
        load ? null:<>

            {props.sno === '8.0' ? <tr></tr> : null}
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                {props.sno} 

            </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                {props.name}  <b> <br />{props.target >= 0 ? ("Target(" + props.target + ")") : ""}</b>

            </td>

          

                
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="genderMale4"
                        className="form-control" maxLength="4" onKeyPress={inputHandler}
                        name="genderMale4"
                        style={{ textAlign: 'center' }}
                        onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                    onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        onChange={(e) => onInputChange(e)}
                        defaultValue={formData.GenderMale4}
                    /> : formData.GenderMale4}

            </td>
            
               <td ></td>
                
    
         
        </>
    );
};

export default NCSCUpdate1;
